import { render } from "./componentEditUz.vue?vue&type=template&id=53a7e6d6"
import script from "./componentEditUz.vue?vue&type=script&lang=js"
export * from "./componentEditUz.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__